<script setup lang="ts">
const { hotelData } = defineProps<{
  hotelData: Partial<HotelInfoExpand>;
}>();

const { t } = useI18n();

const facilityBaseData = computed(() => [
  ...(hotelData?.bars || []),
  ...(hotelData?.bar ? [hotelData.bar] : []),
  ...(hotelData?.roofTopBar ? [hotelData.roofTopBar] : []),
  ...(hotelData?.pools || []),
  ...(hotelData?.genericFacilities || []),
  ...(hotelData?.coworkings || []),
]);

const resolvedFacilities = computed(() => {
  return facilityBaseData.value.map((facility) => ({
    title: facility.title,
    text: facility.description,
    image: facility.heroImage,
  }));
});
</script>

<template>
  <ContentfulColumns
    :title="t('website.pagetype.hotel.property_hightlights')"
    :columns="resolvedFacilities"
    :columnsPerView="4"
    data-component="curatedCollection"
    data-component-variant="slider"
  />
</template>
